import { Col, Row } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";

import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import { glAccountDetails } from "../../../data/accounting";

import "./GLAccounts.css";

const GLAccountsRightBar = [
  RightBarMethod("", "t1", <i className=""></i>, [
    RightBarMethod("", "1", "", "", ""),
  ]),
];

function GLAccounts() {

  const navigate = useNavigate();
  return (
    <>
      <div className="gl-accounts">
        <PageHeading heading="GL Accounts" />
        <div className="gl-accounts-container">
          <Row className="col-container">
            <Col className="span-container" span={18}>
              <span>GL Account</span>
            </Col>
            <Col className="span-container" span={6}>
              <span>Type</span>
            </Col>
          </Row>
          {/* {glAccountDetails.map((item, index) => {
            return (
              <Row key={index} className="account-container" onClick={()=>navigate("/accounting/gl-accounts/gl-account/" + item.id)}>
                <Col className="span-container" span={18}>
                  <span className="onclick-text">{item.accountName}</span>
                </Col>
                <Col className="span-container" span={6}>
                  <span>{item.accountType}</span>
                </Col>
              </Row>
            );
          })} */}
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={GLAccountsRightBar} />
      </div>
    </>
  );
}

export default GLAccounts;
